export default "__VITE_ASSET__CqKQzXw0__"